module.exports = __webpack_public_path__ + "img/history_card.20611194.jpg";